export enum ShipStrategy {
  Trade,
  Halt,
  Change,
  Probe,
  GoTo,
}
